<template>
    <div class="tsi-m-shell" v-show="ready">
        <div class="tsi-page tsi-m">

            <div class="tsi-m-media" v-if="slideImages.length">
                <div v-for="(img, i) in slideImages" :key="img + i"
                     class="tsi-m-media__slide" :class="{'is-active': i === imageIndex}"
                     :style="{backgroundImage: 'url(' + img + ')'}"></div>
                <div class="tsi-m-media__fade"></div>
            </div>

            <header class="tsi-m-header">
                <div class="tsi-m-header__inner">
                    <img class="tsi-m-header__mark" src="/assets/images/tsi-mark.png" alt="TSI"/>
                    <div class="tsi-m-header__titles">
                        <div class="tsi-m-header__cn">{{ appName }}</div>
                        <div class="tsi-m-header__en">TSI · Conference Management</div>
                    </div>
                </div>
            </header>

            <div class="tsi-m-body">
                <div class="tsi-m-lead">
                    <div class="tsi-m-lead__kicker">
                        <i></i><span>Remote Conferencing</span>
                    </div>
                    <h1 class="tsi-m-lead__title">随时随地<br/>开启一场会议</h1>
                </div>

                <div class="tsi-m-login">
                    <div class="tsi-m-card">
                        <div class="tsi-m-card__head">
                            <span class="tsi-m-card__head-cn">登 录</span>
                            <span class="tsi-m-card__head-en">SIGN IN</span>
                        </div>
                        <form action="/" @submit.prevent="submitForm">
                            <div class="tsi-m-card__fields">
                                <label class="tsi-field">
                                    <span class="tsi-field__label">账号</span>
                                    <input type="text" class="tsi-field__input" v-model="login.id"
                                           placeholder="请输入用户名 / 邮箱" autocomplete="username" required>
                                </label>
                                <label class="tsi-field">
                                    <span class="tsi-field__label">密码</span>
                                    <input type="password" class="tsi-field__input" v-model="login.password"
                                           placeholder="请输入密码" autocomplete="current-password" required>
                                </label>
                                <div class="tsi-m-card__row">
                                    <label class="tsi-check">
                                        <input type="checkbox" v-model="remember">
                                        <span>记住账号</span>
                                    </label>
                                </div>
                            </div>
                            <button type="submit" class="tsi-btn" :disabled="process.loading">登 录</button>
                        </form>
                        <div class="tsi-m-card__alt" v-if="wxCorpEnabled">
                            <a href="javascript:void(0);" class="tsi-login__alt-link" @click="jumpToWechatCorp">
                                <i class="fa fa-qrcode"></i> 企业微信扫码登录
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tsi-m-caps">
                <div class="tsi-m-caps__cell" v-for="c in caps" :key="c.title">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#A98A4E"
                         stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" v-html="c.icon"></svg>
                    <div class="tsi-m-caps__title">{{ c.title }}</div>
                    <p class="tsi-m-caps__body">{{ c.body }}</p>
                </div>
            </div>

            <footer class="tsi-m-footer">
                <div class="tsi-m-footer__inner">
                    <div class="tsi-m-footer__org">上海韬视信息技术有限公司</div>
                    <div>支持的浏览器：Chrome / Safari / Firefox / Edge，国内浏览器请使用极速模式。</div>
                    <div class="tsi-m-footer__muted">TEL 021-54412956&#12288;Email service@tsied.com</div>
                    <div class="tsi-m-footer__muted">版权所有 © {{ year }} 上海韬视&#12288;沪ICP备16023729号</div>
                </div>
            </footer>

            <el-dialog append-to-body width="90%" title="错误" :visible.sync="show_login_error"
                       :close-on-click-modal="false" v-mobile-dialog>
                <div v-html="error_message"></div>
                <div slot="footer">
                    <el-button type="primary" @click="jumpToSignIn">关 闭</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import SignInTsi from "@/views/mixins/sign-in-tsi"
import "@/scss/sign-in-tsi.scss"

export default {
    name: "sign-in-tsi",
    mixins: [SignInTsi],
    data() {
        return {
            step: 0,
            // 手机上只放两栏，文案按窄屏重写过；「安全」这条不提 SSO——
            // 韬视自己这套没有接统一认证，写上会误导
            caps: [
                {
                    title: '高效',
                    body: '合理安排资源，实时监控会议使用情况。',
                    icon: '<circle cx="12" cy="12" r="9.2"></circle><path d="M12 6.8V12l3.6 2.2"></path>'
                },
                {
                    title: '安全',
                    body: '私有化部署，等候室与锁定会议保障安全。',
                    icon: '<path d="M12 2.8l7.5 3v6c0 4.4-3.1 8.2-7.5 9.4-4.4-1.2-7.5-5-7.5-9.4v-6z"></path><path d="M9.2 12.2l2 2 3.6-3.9"></path>'
                },
            ],
        }
    },
    computed: {
        appName() {
            return (this.preset.app && this.preset.app.name) || '韬视视频会议管理系统';
        },
        year() {
            return new Date().getFullYear();
        },
        imageIndex() {
            const n = this.slideImages.length;
            if (!n) return 0;
            return this.step % n;
        },
    },
    mounted() {
        // 原型是一张静态主视觉；后台「背景图片」实际配了多张，
        // 这里只做慢速交叉淡入，不加圆点箭头，保持原型的干净观感
        if (this.slideImages.length > 1) this.startAuto();
    },
    watch: {
        slideImages(list) {
            if (list.length > 1) this.startAuto();
        },
    },
    beforeDestroy() {
        clearInterval(this.autoTimer);
    },
    methods: {
        startAuto() {
            clearInterval(this.autoTimer);
            this.autoTimer = setInterval(() => {
                this.step = this.step + 1;
            }, 7000);
        },
    },
}
</script>
